import React, { useContext } from 'react';
import styles from './QuestionCard.module.css';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { PrimaryButton, SecondaryButton } from '../Buttons/Buttons';
import { StoreContext } from '../../utils/store';
import { BsCardImage } from 'react-icons/bs';

const QuestionCard = (props) => {
  const context = useContext(StoreContext);
  const [api] = context.api;
  const [, setModalStatus] = context.modalStatus;

  // api call functions
  const deleteQuestion = async () => {
    const newQuestions = [...props.quiz.questions];
    newQuestions.splice(props.id, 1);
    const response = await api.makeAPIRequest(`admin/quiz/${props.quizid}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({
        questions: newQuestions,
      })
    });
    try {
      const json = await response.json();
      if (response.status === 200) {
        console.log('Delete question ', props.id);
        props.updateDelete(!props.delete);
      } else {
        setModalStatus(status => ({
          ...status,
          modalActive: true,
          overlayActive: true,
          modalHeaderText: 'Error',
          modalBodyText: json.error,
          modalColors: 'error',
        }));
      }
    } catch (e) {
      console.log('ERROR', e);
      setModalStatus(status => ({
        ...status,
        modalActive: true,
        overlayActive: true,
        modalHeaderText: 'Error',
        modalBodyText: 'Sorry! Can\' connect to the server.',
        modalColors: 'error',
      }));
    }
  };

  return (
    <div className={styles.card}>
      <h4 className={styles.title}>{`Question ${props.id + 1}`}</h4>
      <p className={styles.question}>{props.question.qString}</p>
      {props.question.mediaType === 'img'
        ? <>
          {!props.question.img
            ? <div
                className={styles.mediaContainer}
              >
              <BsCardImage className={styles.icon} />
              </div>
            : <div className={styles.mediaContainer}>
              <img
                className={styles.image}
                style={{ backgroundColor: '#f0f0f0' }}
                src={props.question.img}
                alt={`question ${props.id} thumbnail`}
              />
              </div>
          }
          </>
        : <>
          {!props.question.video
            ? <div
                className={styles.mediaContainer}
              >
              <BsCardImage className={styles.icon} />
              </div>
            : <div className={styles.mediaContainer}>
                <iframe
                  className={styles.image}
                  src={props.question.video}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen>
                </iframe>
              </div>
          }
          </>
      }

      <div className={styles.buttons}>
        <Link to={`/game/${props.quizid}/${props.id}`}>
          <PrimaryButton
            className={styles.button}
          >
            <span>Edit</span>
          </PrimaryButton>
        </Link>
        <SecondaryButton
          className={styles.button}
          onClick={deleteQuestion}
        >
          <span>Delete</span>
        </SecondaryButton>
      </div>
    </div>
  );
};

QuestionCard.propTypes = {
  quizid: PropTypes.string,
  id: PropTypes.number,
  delete: PropTypes.bool,
  updateDelete: PropTypes.func,
  quiz: PropTypes.object,
  title: PropTypes.string,
  question: PropTypes.object,
};

export default QuestionCard;
